import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { IDocumentSummaryInfo } from '../../../message-models/document-summary-info.interface';
import { MenuItem } from 'primeng/api';
import { DocumentEntityType } from '../../../message-models/document-entity-type.enum';

@Component({
  selector: 'app-company-documents',
  templateUrl: './company-documents.component.html',
  styleUrls: ['./company-documents.component.scss']
})
export class CompanyDocumentsComponent implements OnInit {
  @Input() showTableCaption: boolean;
  @Input() companyDocuments: Array<IDocumentSummaryInfo>;
  @Output() openCompanyDocument: EventEmitter<IDocumentSummaryInfo> = new EventEmitter<IDocumentSummaryInfo>();
  @Output() addCompanyDocument: EventEmitter<void> = new EventEmitter<void>();
  @Output() editCompanyDocument: EventEmitter<IDocumentSummaryInfo> = new EventEmitter<IDocumentSummaryInfo>();
  @Output() downloadCompanyDocument: EventEmitter<IDocumentSummaryInfo> = new EventEmitter<IDocumentSummaryInfo>();
  @Output() deleteCompanyDocumentClick: EventEmitter<IDocumentSummaryInfo> = new EventEmitter<IDocumentSummaryInfo>();
  @Input() headerText = 'Our Documents';
  @Input() showCount = false;
  @Input() addDocumentButtonText = 'Add';
  @Input() showAddDocumentButton = true;
  rowMenuItems: MenuItem[];
  constructor(private router: Router) {
  }

  isOnMobile = false;
  ngOnInit(): void {
    this.isOnMobile = window.outerWidth <= 480;

    this.rowMenuItems = [
      {
        label: 'Preview',
        icon: 'fas fa-search',
        state: { 'contextLogic': 'canPreviewDocument' },
        styleClass: 'eca-menu-item-green',
        command: ($event) => this.openDocument($event)
      },
      {
        label: 'Edit',
        icon: 'fas fa-edit',
        styleClass: 'eca-menu-item-green',
        command: ($event) => this.editDocument($event)
      },
      {
        label: 'Download',
        icon: 'fas fa-download',
        styleClass: 'eca-menu-item-green',
        command: ($event) => this.downloadDocument($event)
      },
      {
        label: 'Remove',
        icon: 'fas fa-trash-alt',
        styleClass: 'eca-menu-item-red',
        command: ($event) => this.deleteCompanyDocument($event)
      }
    ]
  }

  openDocument(companyDocument: IDocumentSummaryInfo) {
    this.openCompanyDocument.emit(companyDocument);
  }

  deleteCompanyDocument(companyDocument: any) {
    this.deleteCompanyDocumentClick.emit(companyDocument);
  }

  downloadDocument(companyDocument: any) {
    this.downloadCompanyDocument.emit(companyDocument);
  }

  editDocument(companyDocument: any) {
    this.editCompanyDocument.emit(companyDocument);
  }

  viewCompanyDocumentClicked(companyDocument: IDocumentSummaryInfo) {
    if (companyDocument.entityType === DocumentEntityType.company) {
      this.router.navigate(['company-document', companyDocument.documentId]);
    }
    else if (companyDocument.entityType === DocumentEntityType.trainingCourse) {
      this.router.navigate(['/training-course-document/', companyDocument.documentId]);
    }
    else if (companyDocument.entityType === DocumentEntityType.observation) {
      this.router.navigate(['/observation-document/', companyDocument.documentId]);
    }
  }

  addDocumentClicked() {
    this.addCompanyDocument.emit();
  }
}
